module.exports = __webpack_public_path__ + "assets/img/18_932_big.e3a0118f.jpg";